module.exports = __webpack_public_path__ + "img/icon-menu-dots-active.674582a0.svg";